"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = exports.reverse = exports.autocomplete = void 0;
var lonlat_1 = require("@conveyal/lonlat");
var querystring_1 = require("querystring");
var AUTOCOMPLETE_URL = "https://photon.komoot.io/api";
var GEOCODE_URL = "https://photon.komoot.io/api";
var REVERSE_URL = "https://photon.komoot.io/reverse";
function GeocoderException(message) {
    this.message = message;
    this.name = "GeocoderException";
}
function run(_a) {
    var options = _a.options, query = _a.query, url = _a.url;
    return fetch("".concat(url, "?").concat((0, querystring_1.stringify)(query)), options).then(function (res) { return res.json(); });
}
/**
 * Search for an address using
 * Komoot's Photon {@link https://github.com/komoot/photon}
 * service.
 *
 * @param  {Object} $0
 * @param  {Object} $0.boundary
 * @param  {Object} $0.focusPoint
 * @param  {Object} $0.options                    options to pass to fetch (e.g., custom headers)
 * @param  {number} [$0.size=20]
 * @param  {string} $0.text                       query text
 * @return {Promise}                              A Promise that'll get resolved with the autocomplete result
 */
function autocomplete(_a) {
    var boundary = _a.boundary, focusPoint = _a.focusPoint, options = _a.options, _b = _a.size, size = _b === void 0 ? 20 : _b, text = _a.text, _c = _a.url, url = _c === void 0 ? AUTOCOMPLETE_URL : _c;
    return __awaiter(this, void 0, void 0, function () {
        var query, _d, lat, lon, res, country, rect;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    query = { limit: size, q: text };
                    if (!focusPoint) return [3 /*break*/, 2];
                    _d = (0, lonlat_1.normalize)(focusPoint), lat = _d.lat, lon = _d.lon;
                    query.lat = lat.toString();
                    query.lon = lon.toString();
                    return [4 /*yield*/, run({ options: options, query: query, url: url })];
                case 1:
                    res = _e.sent();
                    return [2 /*return*/, res];
                case 2:
                    if (boundary) {
                        country = boundary.country, rect = boundary.rect;
                        if (country)
                            query.in = "countryCode:".concat(country);
                        if (rect) {
                            query.in = "bbox:".concat([
                                rect.minLon,
                                rect.minLat,
                                rect.maxLon,
                                rect.maxLat
                            ].join(","));
                        }
                    }
                    return [2 /*return*/, run({ options: options, query: query, url: url })];
            }
        });
    });
}
exports.autocomplete = autocomplete;
/**
 * Search for an address using
 * Komoot's Photon {@link https://github.com/komoot/photon}
 * service.
 *
 * @param  {Object} $0
 * @param  {Object} $0.focusPoint
 * @param  {Object} $0.options                  options to pass to fetch (e.g., custom headers)
 * @param  {number} [$0.size=10]
 * @param  {string} $0.text                      The address text to query for
 * @return {Promise}                            A Promise that'll get resolved with search result
 */
function search(_a) {
    var focusPoint = _a.focusPoint, options = _a.options, _b = _a.size, size = _b === void 0 ? 10 : _b, text = _a.text, _c = _a.url, url = _c === void 0 ? GEOCODE_URL : _c;
    if (!text)
        return Promise.resolve({ items: [] });
    var query = {
        limit: size,
        q: text
    };
    if (focusPoint) {
        var _d = (0, lonlat_1.normalize)(focusPoint), lat = _d.lat, lon = _d.lon;
        query.lat = lat.toString();
        query.lon = lon.toString();
    }
    return run({ options: options, query: query, url: url });
}
exports.search = search;
/**
 * Search for an address using
 * Komoot's Photon {@link https://github.com/komoot/photon} reverse
 * service.
 *
 * @param  {Object} $0
 * @param  {Object} $0.point
 * @param  {Object} $0.options                  options to pass to fetch (e.g., custom headers)
 * @return {Promise}                            A Promise that'll get resolved with search result
 */
function reverse(_a) {
    var options = _a.options, point = _a.point, _b = _a.url, url = _b === void 0 ? REVERSE_URL : _b;
    var query = {};
    if (point) {
        var _c = (0, lonlat_1.normalize)(point), lat = _c.lat, lon = _c.lon;
        query.lat = lat.toString();
        query.lon = lon.toString();
    }
    else {
        throw new GeocoderException("No point provided for reverse geocoder.");
    }
    return run({ options: options, query: query, url: url }).then(function (res) { return (__assign(__assign({}, res), { point: point })); });
}
exports.reverse = reverse;
//# sourceMappingURL=index.js.map